import PopTextBox from './poptextbox.vue';
export default PopTextBox;


// WEBPACK FOOTER //
// ./src/components/poptextbox/index.js